import React, { useEffect, useState } from 'react';
import { Button, Spin } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import callApi from '../../../Api/config';
import { PHOTOMITRA_PHOTO_GUIDELINES_PAGE_ENTITY } from '../../../constants/EntityName';
import { toastError, toastSuccess } from '../../../service/Toast';

const modules = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ size: ['small', false, 'large', 'huge'] }, { color: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }, { align: [] }],
      ['link', 'image'],
      ['clean'],
      ['code-block'],
    ],
  },
  clipboard: { matchVisual: false },
};

const PhotomitraPhotoGuidelines = () => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState('');
  const [recordId, setRecordId] = useState<string | null>(null);

  const fetchGuideline = async () => {
    setLoading(true);
    try {
      const res = await callApi(
        PHOTOMITRA_PHOTO_GUIDELINES_PAGE_ENTITY,
        'GET',
        null,
        { page: 1, limit: 1 }
      );
      const record = res?.data?.data?.results?.[0];
      if (record) {
        setRecordId(record.id);
        setContent(record.content || '');
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGuideline();
  }, []);

  const handleSave = async () => {
    try {
      const payload = { content };

      setLoading(true);
      let res: any;

      if (recordId) {
        res = await callApi(
          `${PHOTOMITRA_PHOTO_GUIDELINES_PAGE_ENTITY}/${recordId}`,
          'PATCH',
          payload
        );
      } else {
        res = await callApi(PHOTOMITRA_PHOTO_GUIDELINES_PAGE_ENTITY, 'POST', payload);
        const newId = res?.data?.data?.id;
        if (newId) setRecordId(newId);
      }

      if (res?.status) {
        toastSuccess('Photo Guidelines saved successfully!');
      } else {
        toastError('Failed to save Photo Guidelines. Please try again.');
      }
    } catch (err) {
      toastError('Failed to save Photo Guidelines. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <div style={{ padding: '32px', maxWidth: 960 }}>
        <h2 style={{ marginBottom: 24, fontWeight: 600, fontSize: 20 }}>Photo Guidelines</h2>

        <div>
          <label style={{ fontWeight: 500, display: 'block', marginBottom: 8 }}>Content</label>
          <ReactQuill
            theme="snow"
            modules={modules}
            value={content}
            onChange={setContent}
            style={{ minHeight: 320 }}
          />
        </div>

        <div style={{ marginTop: 56 }}>
          <Button
            type="primary"
            onClick={handleSave}
            size="large"
            style={{ background: '#586f80', borderColor: '#586f80', minWidth: 120 }}
          >
            {recordId ? 'Update' : 'Save'}
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default PhotomitraPhotoGuidelines;
